import { render } from "./InstallationWorksSvg.vue?vue&type=template&id=c1ab80b2"
import script from "./InstallationWorksSvg.vue?vue&type=script&lang=js"
export * from "./InstallationWorksSvg.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__